<template>
  <v-card-text>
    <p v-html="service.description.short"></p>
  </v-card-text>
</template>

<script>
  export default {
    props: {
      service: {
        type: Object,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/service/Content.vue